import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ENDPOINTS } from '../constants/app-values';
import { Empresa, Proceso } from '../../classes/coordinador';
import { AppStorage } from './appStorage.service';
import { isDefined } from '@angular/compiler/src/util';
import { isUndefined } from 'util';

@Injectable({
  providedIn: 'root'
})
export class ApiDocumentosService {
  constructor(private httpClient: HttpClient, private appStorage: AppStorage) {}

  API_URL = 'http://services.beta-ifc.coordinador.cl:8000';
  API_URL_DOC = ENDPOINTS.HOST + '/documentos/';

  getAllDocumentos() {
    const headers = new HttpHeaders({
      'Content-type': 'application/json',
      Authorization: this.appStorage.token
    });

    return this.httpClient
      .get(`${ENDPOINTS.HOST}/documentos/todos`, { headers: headers })
      .toPromise();
  }

  getAllDocumentosCoordinador(anno, mes, proceso) {
    const headers = new HttpHeaders({
      'Content-type': 'application/json',
      Authorization: this.appStorage.token
    });

    const body = {
      idProceso: proceso.idProceso,
      anio: anno,
      mes: mes
    };

    return this.httpClient
      .post(`${ENDPOINTS.HOST}/documento/historico/`, body, {
        headers: headers
      })
      .toPromise();
  }

  getAllDocumentosUsuarioEmpresa(anno, mes, proceso) {
    const headers = new HttpHeaders({
      'Content-type': 'application/json',
      Authorization: this.appStorage.token
    });

    const body = {
      idProceso: proceso.idProceso,
      anio: anno,
      mes: mes
    };

    return this.httpClient
      .post(`${ENDPOINTS.HOST}/documentos/usuario/empresa/`, body, {
        headers: headers
      })
      .toPromise();
  }

  getAllDocumentosUsuarioEmpresaDescarga(anno, mes, proceso) {
    const headers = new HttpHeaders({
      'Content-type': 'application/json',
      Authorization: this.appStorage.token
    });

    let mesNumero = '';

    if (mes) {
      mesNumero = mes.numero + '';
    }

    const body = {
      idProceso: proceso.idProceso,
      anio: anno,
      mes: mesNumero
    };

    return this.httpClient
      .post(`${ENDPOINTS.HOST}/documento/empresa/descarga/`, body, {
        headers: headers
      })
      .toPromise();
  }

  getAllDocumentosCoordinadorDescarga(anno, mes, proceso) {
    const headers = new HttpHeaders({
      'Content-type': 'application/json',
      Authorization: this.appStorage.token
    });

    let mesNumero = '';

    if (mes) {
      mesNumero = mes.numero + '';
    }

    const body = {
      idProceso: proceso.idProceso,
      anio: anno,
      mes: mesNumero
    };

    return this.httpClient
      .post(`${ENDPOINTS.HOST}/documento/descarga/`, body, {
        headers: headers
      })
      .toPromise();
  }

  getAllDocumentosCoordinadorDescargaPublico(anno, mes, proceso) {
    const headers = new HttpHeaders({
      'Content-type': 'application/json'
    });

    let mesNumero = '';

    if (mes) {
      mesNumero = mes.numero + '';
    }

    const body = {
      idProceso: proceso.idProceso,
      anio: anno,
      mes: mesNumero
    };

    return this.httpClient
      .post(`${ENDPOINTS.HOST}/publico/documento/descarga/`, body, {
        headers: headers
      })
      .toPromise();
  }

  getAllDocumentosPublico(anno, mes, proceso) {
    const headers = new HttpHeaders({
      'Content-type': 'application/json'
    });

    const body = {
      idProceso: proceso.idProceso,
      anio: anno,
      mes: mes
    };

    return this.httpClient
      .post(`${ENDPOINTS.HOST}/publico/documento/`, body, {
        headers: headers
      })
      .toPromise();
  }

  getDocumentosEmpresa() {
    const headers = new HttpHeaders({
      'Content-type': 'application/json',
      Authorization: this.appStorage.token
    });

    return this.httpClient
      .get(`${ENDPOINTS.HOST}/documentos/usuario/estado/Publicado`, {
        headers: headers
      })
      .toPromise();
  }

  getDocumentosCargaCoordinador(anno, mes, proceso, estado) {
    const headers = new HttpHeaders({
      'Content-type': 'application/json',
      Authorization: this.appStorage.token
    });

    const body = {
      idProceso: proceso.idProceso,
      anio: anno,
      mes: mes,
      estado: estado
    };

    return this.httpClient
      .post(`${ENDPOINTS.HOST}/documentos/filtrados/`, body, {
        headers: headers
      })
      .toPromise();
  }

  eliminarDocumento(idDocumento) {
    const headers = new HttpHeaders({
      'Content-type': 'application/json',
      Authorization: this.appStorage.token
    });

    return this.httpClient
      .delete(`${ENDPOINTS.HOST}/documento/${idDocumento}/`, {
        headers: headers
      })
      .toPromise();
  }

  subirDocumentoTmp(archivos, anno, mes, plazoCargaCoordinador, proceso) {
    const today = new Date();
    const diasAtraso = this.diffDays(plazoCargaCoordinador, today);

    const headers = new HttpHeaders({
      'Content-type': 'application/json',
      Authorization: this.appStorage.token
    });

    const body = [];

    for (const archivo of archivos) {
      body.push({
        ProcesoDetalle: {
          idEmpresa: archivo.idEmpresa,
          idProceso: proceso.idProceso,
          anio: anno,
          mes: mes
        },
        Documentos: [
          {
            url: archivo.url,
            version: archivo.nombreASubir.substring(0, 4),
            nombreArchivo: archivo.nombreASubir,
            diaSubida: today.getDate(),
            anioSubida: today.getFullYear(),
            mesSubida: today.getMonth() + 1,
            diasAtraso: diasAtraso < 0 ? 0 : diasAtraso,
            estado: 'Pendiente'
          }
        ]
      });
    }

    console.log(body);

    return this.httpClient
      .post(`${ENDPOINTS.HOST}/documentos/coordinador/`, body, {
        headers: headers
      })
      .toPromise();
  }

  publicarDocumentosCoordinador(
    anno,
    mes,
    proceso,
    plazoCargaEmpresa: Date,
    plazoCargaCoordinador: Date
  ) {
    const headers = new HttpHeaders({
      'Content-type': 'application/json',
      Authorization: this.appStorage.token
    });

    const body = {
      idProceso: proceso.idProceso,
      anio: anno,
      mes: mes,
      estado: 'Publicado',
      plazoMaxEmpresa:
        plazoCargaEmpresa.getFullYear() +
        '-' +
        (plazoCargaEmpresa.getMonth() + 1) +
        '-' +
        plazoCargaEmpresa.getDate(),
      plazoMaxCoordinador:
        plazoCargaCoordinador.getFullYear() +
        '-' +
        (plazoCargaCoordinador.getMonth() + 1) +
        '-' +
        plazoCargaCoordinador.getDate()
    };

    return this.httpClient
      .post(`${ENDPOINTS.HOST}/documentos/coordinador/publicar/`, body, {
        headers: headers
      })
      .toPromise();
  }

  publicarDocumentos(
    empresa: Empresa,
    proceso: Proceso,
    anno,
    mes,
    plazoMaxEmpresa,
    archivo
  ) {
    const today = new Date();
    const diasAtraso = this.diffDays(plazoMaxEmpresa, today);

    const headers = new HttpHeaders({
      Authorization: this.appStorage.token
    });

    const body = {
      Origen: 'empresa',
      ProcesoDetalle: {
        idEmpresa: empresa.idEmpresa,
        idProceso: proceso.idProceso,
        anio: anno,
        mes: mes
      },
      Documentos: [
        {
          url: archivo.url,
          version: archivo.nombreAPublicar.substring(0, 4),
          nombreArchivo: archivo.nombreAPublicar
        }
      ]
    };

    return this.httpClient
      .post(this.API_URL_DOC, body, { headers: headers })
      .toPromise();
  }

  descargarDocumento(URL) {
    return this.httpClient
      .get(URL, {
        responseType: 'blob'
      })
      .toPromise();
  }

  diffDays(d1, d2) {
    let ndays;
    const tv1 = d1.getTime(); // msec since 1970
    const tv2 = d2.getTime();

    ndays = (tv2 - tv1) / 1000 / 86400;
    ndays = Math.round(ndays - 0.5);
    return ndays;
  }
}
